import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FiltersEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { FILTER_DEFINITIONS } from 'site-modules/lease-deals/components/filters/infrastructure/filters-config';
import { CollapsibleFiltersGroup } from 'site-modules/lease-deals/components/filters/ui/primitives/collapsible-filters-group/collapsible-filters-group';
import { ConnectedFilterItem } from 'site-modules/lease-deals/components/filters/infrastructure/connected-filter-item/connected-filter-item';
import { GroupConfigEntity } from 'site-modules/lease-deals/components/filters/entities/group-entities';

export const FilterGroupContainer = memo(({ groupConfig, filtersData, onFilterUpdate }) => {
  const { isCollapsible, title, isOpenOnLoad, hideCollapseSeparator, items } = groupConfig;

  const renderedChildren = items
    .map(config => {
      const id = config.id;
      const definition = FILTER_DEFINITIONS[id];
      const optionsKey = definition?.controlProps?.optionsKey;
      const options = filtersData[optionsKey];

      if (optionsKey && !options) return null;

      return (
        <ConnectedFilterItem
          key={id}
          config={{ ...definition, ...config }}
          options={options}
          onFilterUpdate={onFilterUpdate}
        />
      );
    })
    .filter(Boolean);

  if (renderedChildren.length === 0) return null;

  if (isCollapsible) {
    return (
      <CollapsibleFiltersGroup
        textClosed={title}
        textOpen={title}
        isOpenOnLoad={isOpenOnLoad}
        hideCollapseSeparator={hideCollapseSeparator}
        collapseClassName="pb-1_25"
        trackingId="view_filter_section"
        collapseTrackingId="close_filter_section"
        trackingValue={title}
      >
        {renderedChildren}
      </CollapsibleFiltersGroup>
    );
  }

  return renderedChildren;
});

FilterGroupContainer.displayName = 'FilterGroupContainer';

FilterGroupContainer.propTypes = {
  groupConfig: GroupConfigEntity.isRequired,
  filtersData: FiltersEntity.isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
};
